import axios from "axios";
import config from "../config";

export function disconnectService(service) {
  return axios.post(`${config.api_url}/disconnect/${service}`);
}

export function loginStreet(body) {
  return axios.post(`${config.api_url}/street/config`, body);
}
